module.exports = __webpack_public_path__ + "static/media/download-disabled.ab91d6ac.png";